import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetPoliticaHistorico() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const getPoliticaHistorico = useCallback(
        () =>
            invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/Politica/historico`,
                method: 'GET',
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        getPoliticaHistorico,
    };
}
